export const iambicPentameterPool = [
    {
      line: "Shall I compare thee to a summer's day?",
      isIambic: true,
      distractors: [
        "The quick brown fox jumps over the dog.",
        "Green fields under the blue sky.",
        "Soft music played quietly in the room."
      ]
    }
  ];
  